import { create } from "zustand";

export const HealthStore = create((set) => ({
  healthMapImage: null,
  frequenciaExameValue: null,
  atendimentoAmbulanciaValue: null,
  sistemaSaudeValue: null,

  frequenciaExameImage: null,
  atendimentoAmbulanciaImage: null,
  sistemaSaudeImage: null,

  setFrequenciaExameValue: (val) => set({ frequenciaExameValue: val }),
  setAtendimentoAmbulanciaValue: (val) =>
    set({ atendimentoAmbulanciaValue: val }),
  setSistemaSaudeValue: (val) => set({ sistemaSaudeValue: val }),

  setHealthMapImage: (img) => set({healthMapImage: img}),
  setFrequenciaExameImage: (img) => set({ frequenciaExameImage: img }),
  setAtendimentoAmbulanciaImage: (img) =>
    set({ atendimentoAmbulanciaImage: img }),
  setSistemaSaudeImage: (img) => set({ sistemaSaudeImage: img }),

  usoMedicamentoValue: null,
  dificuldadeAtendimentoValue: null,

  usoMedicamentoImage: null,
  dificuldadeAtendimentoImage: null,
  qualidadeSSMunicipalImage: null,
  qualidadeSSRuralImage: null,

  setUsoMedicamentoValue: (val) => set({ usoMedicamentoValue: val }),
  setDificuldadeAtendimentoValue: (val) =>
    set({ dificuldadeAtendimentoValue: val }),

  setUsoMedicamentoImage: (img) => set({ usoMedicamentoImage: img }),
  setDificuldadeAtendimentoImage: (img) =>
    set({ dificuldadeAtendimentoImage: img }),
  setQualidadeSSMunicipalImage: (img) =>
    set({ qualidadeSSMunicipalImage: img }),
  setQualidadeSSRuralImage: (img) => set({ qualidadeSSRuralImage: img }),

  possuiDoencaCronicaValue: null,
  tipoDoencaCronicaValue: null,
  programaSaudeRuralValue: null,

  possuiDoencaCronicaImage: null,
  tipoDoencaCronicaImage: null,
  programaSaudeRuralImage: null,

  setPossuiDoencaCronicaValue: (val) => set({ possuiDoencaCronicaValue: val }),

  setTipoDoencaCronicaValue: (val) => set({ tipoDoencaCronicaValue: val }),

  setProgramaSaudeRuralValue: (val) => set({ programaSaudeRuralValue: val }),

  setPossuiDoencaCronicaImage: (img) => set({ possuiDoencaCronicaImage: img }),

  setTipoDoencaCronicaImage: (img) => set({ tipoDoencaCronicaImage: img }),

  setProgramaSaudeRuralImage: (img) => set({ programaSaudeRuralImage: img }),

  reset: () =>
    set({
      frequenciaExameValue: null,
      atendimentoAmbulanciaValue: null,
      sistemaSaudeValue: null,
      usoMedicamentoValue: null,
      dificuldadeAtendimentoValue: null,
      possuiDoencaCronicaValue: null,
      tipoDoencaCronicaValue: null,
      programaSaudeRuralValue: null,
    }),
}));
